"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_USER_SETTINGS_FRAGMENT = exports.USER_FIELDS = exports.USER_SETTINGS_FIELDS = exports.COMPLETED_CARDS = void 0;
const client_1 = require("@apollo/client");
const picture_1 = require("./picture");
exports.COMPLETED_CARDS = (0, client_1.gql) `
  ${picture_1.PICTURE_FIELDS}
  fragment UserCompletedCards on User {
    completedCards {
      id
      createdAt
      updatedAt
      concept {
        id
        name
      }
      lastSeen
      reviewDate
      score
      iteration
      optimalFactor
      cardId
      card {
        id
        conceptId
        concept {
          id
          name
        }
        topic {
          id
          name
        }
        question
        explanation
        pictures {
          ...PictureFields
        }
      }
    }
    completedCardsCount
  }
`;
exports.USER_SETTINGS_FIELDS = (0, client_1.gql) `
  fragment UserSettingsFields on UserSettings {
    id
    userId
    updatedAt
    globalSettings {
      dailyFeedMax
      dailyFeedResetTime
      theme
      expandedReading
      disabledColors
      readingTextScale
      addToDailyFlashcards
    }
    productSettings {
      examDate
      nextFeedbackDate
    }
  }
`;
exports.USER_FIELDS = (0, client_1.gql) `
  ${exports.USER_SETTINGS_FIELDS}
  fragment UserFields on User {
    id
    accessLevel
    createdAt
    updatedAt
    displayName
    username
    firstName
    lastName
    classYear
    graduationYear
    universityId
    settings {
      ...UserSettingsFields
    }
    stripeCustomerId
    tocAccepted

    # subscriptions
    subscriptions(active: $active) {
      id
      productId
      periodEndAt
      endedAt
      purchaseSource
      product {
        id
        name
        typeId
        duration
        price
        subscription
        stripePriceId
      }
    }

    # clinical
    qbankSubscriptionEndDate
    osceSubscriptionEndDate
    bundleSubscriptionEndDate

    # pre-clinical
    anatomySubscriptionEndDate
    medicalSciencesSubscriptionEndDate
    anatomyBundleSubscriptionEndDate

    # post-graduate
    mrcpPart1SubscriptionEndDate
    mrcpPart2SubscriptionEndDate
    pacesSubscriptionEndDate
    msraSubscriptionEndDate
    mrcpVideoSubscriptionEndDate

    # interviews
    anaestheticsInterviewSubscriptionEndDate
    cstInterviewSubscriptionEndDate
    imtInterviewSubscriptionEndDate
    radiologyInterviewSubscriptionEndDate
    paediatricsInterviewSubscriptionEndDate

    # plab
    plab1SubscriptionEndDate
    plab2SubscriptionEndDate

    # ucat
    ucatSubscriptionEndDate

    # user-specific keys
    # marksheets
    # marksheetsCount
    # completedQuestionsCount
    # completedCorrectQuestionsCount
    # completedIncorrectQuestionsCount
    # completedCardsCount
    # completedGreenCardsCount
    # completedYellowCardsCount
    # completedRedCardsCount
  }
`;
// used in cache updator
exports.UPDATE_USER_SETTINGS_FRAGMENT = (0, client_1.gql) `
  ${exports.USER_SETTINGS_FIELDS}
  fragment UpdateUserSettingsFragment on User {
    settings {
      ...UserSettingsFields
    }
  }
`;
